import React from 'react'

const TrackMediaIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props} width={props.size ?? 28} height={props.size ?? 28} viewBox="0 0 20 20" fill="none">
            <path d="M1.66797 10.0013C1.66797 6.07293 1.66797 4.10875 2.88836 2.88836C4.10875 1.66797 6.07293 1.66797 10.0013 1.66797C13.9297 1.66797 15.8939 1.66797 17.1142 2.88836C18.3346 4.10875 18.3346 6.07293 18.3346 10.0013C18.3346 13.9297 18.3346 15.8939 17.1142 17.1142C15.8939 18.3346 13.9297 18.3346 10.0013 18.3346C6.07293 18.3346 4.10875 18.3346 2.88836 17.1142C1.66797 15.8939 1.66797 13.9297 1.66797 10.0013Z" stroke="#8C92A2" stroke-width="1.25" />
            <path d="M17.9154 6.66797H2.08203" stroke="#8C92A2" stroke-width="1.25" stroke-linecap="round" />
            <path d="M8.7487 2.08203L5.83203 6.66536" stroke="#8C92A2" stroke-width="1.25" stroke-linecap="round" />
            <path d="M14.1667 2.08203L11.25 6.66536" stroke="#8C92A2" stroke-width="1.25" stroke-linecap="round" />
        </svg>
    )
}

export default TrackMediaIcon